// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voters-modal {
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.voters-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
}

.voters-modal .modal-header h3 {
  margin: 0;
  font-size: 20px;
  color: var(--text-primary);
}

.voters-modal .close-btn {
  background: none;
  border: none;
  font-size: 32px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.voters-modal .close-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.modal-reward-mode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border-color);
  gap: 12px;
}

.modal-reward-mode label {
  font-size: 14px;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.modal-reward-mode select {
  font-size: 13px;
  flex: 1 1;
  min-width: 160px;
}


.voters-modal .modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px;
}

.loading-state,
.error-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--text-secondary);
}

.loading-state .spinner-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.voters-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.voter-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 2px;
  border-bottom: 1px solid var(--border-color);
  transition: background 0.2s;
}

.voter-item:hover {
  background: var(--hover-bg);
}

.voter-rank {
  font-size: 12px;
  color: var(--text-secondary);
  min-width: 24px;
  text-align: right;
}

.voter-name {
  flex: 1 1;
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
}

.voter-name:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.vote-weight {
  font-size: 14px;
  color: var(--accent-primary);
  font-weight: 600;
  min-width: 60px;
  text-align: right;
}

.vote-weight.downvote {
  color: #e53e3e;
}
.vote-reward {
  font-size: 12px;
  color: var(--primary-color);
  font-weight: 500;
  min-width: 80px;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/components/VotersModal/VotersModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;;AAGA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".voters-modal {\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: var(--bg-secondary);\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.voters-modal .modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.voters-modal .modal-header h3 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.voters-modal .close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 32px;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.voters-modal .close-btn:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-reward-mode {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 20px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  gap: 12px;\r\n}\r\n\r\n.modal-reward-mode label {\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.modal-reward-mode select {\r\n  font-size: 13px;\r\n  flex: 1;\r\n  min-width: 160px;\r\n}\r\n\r\n\r\n.voters-modal .modal-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 10px;\r\n}\r\n\r\n.loading-state,\r\n.error-state,\r\n.empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 40px 20px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.loading-state .spinner-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  margin-bottom: 16px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.voters-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.voter-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 2px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  transition: background 0.2s;\r\n}\r\n\r\n.voter-item:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.voter-rank {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  min-width: 24px;\r\n  text-align: right;\r\n}\r\n\r\n.voter-name {\r\n  flex: 1;\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.voter-name:hover {\r\n  opacity: 0.8;\r\n  text-decoration: underline;\r\n}\r\n\r\n.vote-weight {\r\n  font-size: 14px;\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n  min-width: 60px;\r\n  text-align: right;\r\n}\r\n\r\n.vote-weight.downvote {\r\n  color: #e53e3e;\r\n}\r\n.vote-reward {\r\n  font-size: 12px;\r\n  color: var(--primary-color);\r\n  font-weight: 500;\r\n  min-width: 80px;\r\n  text-align: right;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
